import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import WhyUsersSearch from "./components/WhyUsersSearch";
import CategoryCards from "./components/CategoryCards";
import PlatformCards from "./components/PlatformCards";
import HowItWorks from "./components/HowItWorks";
import SafetySection from "./components/SafetySection";
import GuideSection from "./components/GuideSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hipobuyspread.pics';
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg';

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      "name": "Hipobuy Spreadsheet",
      "url": siteUrl,
      "logo": {
        "@type": "ImageObject",
        "url": logoUrl,
        "width": "512",
        "height": "512",
      },
      "description": "The premier resource hub for spreadsheet-based product discovery, offering organized catalogs, comparison guides, and safety information for smart online shoppers.",
      "sameAs": [
        "https://kaspreadsheet.com",
      ],
    },
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      "url": siteUrl,
      "name": "Hipobuy Spreadsheet",
      "description": "Find the latest Hipobuy Spreadsheet resources, category guides, comparison tools and safety tips for smart product discovery.",
      "publisher": {
        "@id": `${siteUrl}/#organization`,
      },
      "inLanguage": "en",
    },
    {
      "@type": "WebPage",
      "@id": `${siteUrl}/#webpage`,
      "url": siteUrl,
      "name": "Hipobuy Spreadsheet 2026 | Verified Spreadsheet Links, Guides & Shopping Resources",
      "description": "Find the latest Hipobuy Spreadsheet resources, category guides, comparison tools and safety tips. Explore verified spreadsheet information and expert shopping guides for smart product discovery.",
      "isPartOf": {
        "@id": `${siteUrl}/#website`,
      },
      "about": {
        "@id": `${siteUrl}/#organization`,
      },
      "datePublished": "2026-06-01",
      "dateModified": "2026-07-09",
      "inLanguage": "en",
    },
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <WhyUsersSearch />
        <CategoryCards />
        <PlatformCards />
        <HowItWorks />
        <SafetySection />
        <GuideSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}